<template>
  <transition name="fade">
    <div
      v-show="$store.state.show === 'page4'"
      :class="['page page4', $store.state.show === 'page4' ? 'active' : '']"
    >
      <div class="content">
        <div class="cont">
          <div :class="['screen screen1', $store.state.screen === 'screen9' ? 'active' : '' ? 'active' : '']">
            <img src="./images/p4-p1-chuan.png" alt="" class="p1-chuan abs opacity" />
            <img src="./images/p4-p1-text.png" alt="" class="p1-text abs opacity" />
          </div>

          <img src="./images/p4-p1-molihua.png" alt="" class="p1-molihua abs" />
        </div>

        <img src="./images/yun-zuo.png" alt="" class="yun-zuo abs" />
        <img src="./images/yun-you.png" alt="" class="yun-you abs" />
        <img :class="['tips-up abs']" src="./images/tips-up.png" alt="" />
      </div>
    </div>
  </transition>
</template>

<script>
import $ from "jquery";
export default {
  name: "page4",
  components: {},
  data() {
    return {};
  },
  methods: {
    // 下一页
    nextPage() {
      this.$store.dispatch("setPageFn", "page4");
    },
  },
  mounted() {
  },
  watch: {
    "$store.state.show"() {
      // 你需要执行的代码
      if (this.$store.state.show === "page4") {
        // this.pageOperate();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/mixin";

.page4 {
  background: url("./images/p4-p1-bg.jpg") top center no-repeat;
  background-size: 100% auto;

  .screen4 {
    z-index: 13;
  }

  .screen1.active {
    .p1-text {
      -webkit-animation: identifierx 0.6s ease-out 0.2s;
      animation: identifierx 0.6s ease-out 0.2s;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
    .p1-chuan {
      -webkit-animation: identifierxl 0.6s ease-out 0.2s;
      animation: identifierxl 0.6s ease-out 0.2s;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
  }

  .content {
    .p1-chuan {
      top: 684px;
      left: 0;
      width: 404px;
    }

    .p1-text {
      top: 37px;
      right: 0;
      width: 724px;
    }

    .p1-molihua {
      width: 100%;
      bottom: 0;
      left: 0;
      z-index: 10;
    }

  }
}
</style>
